import { FC } from 'react';

import styled from '@emotion/styled';

import { LoadingContainer } from '@britishcouncil/react-solas';
import { PageContainer as PageContainerBase } from '@britishcouncil/react-solas-ors3';

export const PageContainer: FC<{ loading?: boolean }> = ({ loading, children }) => (
  <LoadingContainer loading={loading}>
    <PageContainerBase>
      <StyledContainer>{children}</StyledContainer>
    </PageContainerBase>
  </LoadingContainer>
);

const StyledContainer = styled.div`
  min-height: 100px;
`;
